import React, { useContext, useEffect } from 'react'
import Container from '../../../../../constants/Container'
import { Grid, Typography } from '@mui/material'
import LabelBox from '../../../../../constants/LabelBox'
import { formatMoney_2 } from '../../../../../helpers/DateFormat';
import AmountInputBox from '../../../../../constants/AmountInputBox';
import { BillingContext } from '../../../../../context/BillinEntryContext';
import ParticularFormView from './widgets/ParticularFormView';
import { useSelector } from 'react-redux';
interface RightTransProps {
    data: any;
}
const RightTranFormView: React.FC<RightTransProps> = ({ data }) => {
    const context = useContext(BillingContext);
    const billingParticularList = useSelector(
        (state: any) => state.accounts.BillingParticularList
    );
    const totalParticularAmount = billingParticularList?.reduce((sum: number, item: any) => {
        return sum + (Number(item.amount) || 0);
    }, 0);
    useEffect(() => {
        const totalRightAmt = (data?.fixed_month_amt || 0) + values.fine_amt - values.chhut_amt;
        setFieldValue('right_total_amt', totalRightAmt + totalParticularAmount);
        setFieldValue('tot_particular_amt', totalParticularAmount);
        setFieldValue('total_every_month_amt', data?.fixed_month_amt);
    }, [data?.fixed_month_amt, context?.values.fine_amt, context?.values.member_sn, context?.values.chhut_amt, totalParticularAmount]);

    // Calculate the sum of total_amount
    if (!context) {
        return <Typography>Error: Context not available</Typography>;
    }
    const { values, setFieldValue, handleChange, handleBlur, touched, errors } = context;
    return (
        <Grid container spacing={1}>
            <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                <Container padding>
                    <Grid container spacing={1}>
                        <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                            <div className='text-sm px-2 py-0.5 flex justify-end'>
                                <h1 className='text-slate-900 font-medium dark:text-slate-400'><span>Total Mahasul: </span> <span className='text-red-500 font-bold'> {formatMoney_2(data?.fixed_month_amt || 0)}</span></h1>
                            </div>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                            <AmountInputBox name='fine_amt' value={values.fine_amt || 0} handleChange={handleChange} label={'Fine Amount'} />
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                            <AmountInputBox name='chhut_amt' value={values.chhut_amt} handleChange={handleChange} label={'Chhut Amount'} />
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                            <LabelBox label='Total' value={formatMoney_2(data?.fixed_month_amt + values.fine_amt - values.chhut_amt)} />
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                            <ParticularFormView data={data} />
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
                            <LabelBox label='Total' value={formatMoney_2(totalParticularAmount)} />
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </Grid >
    )
}

export default RightTranFormView